/**
 * 趣味关系卡片
 * */
import React, { useState } from 'react';
import Util from '../../../script/util';
import './InterestAffinityCard.scss';
import InterestAffinityDetailModal from './InterestAffinityDetailModal';
import InterestAffinityAvatar from './InterestAffinityAvatar';

const InterestAffinityCard = ({
  data,
  children,
  isTime = true,
  isOpenDetail,
}) => {
  const [detailVisible, setDetailVisible] = useState(false);

  const openDetail = () => {
    if (isOpenDetail) {
      setDetailVisible(true);
    }
  };
  const closeDetail = () => {
    setDetailVisible(false);
  };
  return (
    <>
      <div
        className="interest-affinity-card-item"
        style={{
          backgroundImage: `url(${Util.transImgUrl(data?.cardHorizontal, '345x148')})`,
        }}
        onClick={openDetail}
      >
        {data?.remainDays && isTime ? (
          <div className="interest-affinity-card-item-day">
            剩余{data.remainDays}
          </div>
        ) : null}
        {children}
        <InterestAffinityAvatar data={data} />
      </div>
      <InterestAffinityDetailModal
        visible={detailVisible}
        data={data}
        onClose={closeDetail}
      />
    </>
  );
};

export default InterestAffinityCard;
